import { FC, useState, useEffect } from 'react';
import { ProductVM } from '../../../../common/view-model';
import './DescriptionComponent.scss';
import { OverviewState } from '../../overview//model';
import { findFactPanelImage } from '../../../../helpers/handleFindFactPanelImage';
import { Image } from '../../../../common/model';
import Modal from 'react-bootstrap/Modal';
import InnerImageZoom from 'react-inner-image-zoom';

interface IDistributionComponentProps {
	product: ProductVM | undefined;
}

interface INutritionFactModalComponentProps {
	image: Image | undefined;
	onCloseModal: () => void;
	showModal: boolean;
}
const NutritionFactModalComponent: FC<INutritionFactModalComponentProps> = ({
	image,
	onCloseModal,
	showModal
}) => {
	return (
		<Modal
			show={showModal}
			aria-labelledby='example-custom-modal-styling-title'
			className='nutrition-fact-modal-container'
			onHide={onCloseModal}
		>
			<Modal.Body>
				<div className='modal-item'>
					{image?.mainUrl && <InnerImageZoom src={image?.mainUrl!} />}
				</div>
			</Modal.Body>
			<b className='close_icon' onClick={onCloseModal}>
				&times;
			</b>
			<i className='ri-zoom-in-line zoom-icon'></i>
		</Modal>
	);
};

export const DescriptionComponent: FC<IDistributionComponentProps> = ({ product }) => {
	const [ingredient, setIngredient] = useState({ ...OverviewState, product });
	const [nutritionFactImage, setNutritionFactImage] = useState<Image | undefined>(
		findFactPanelImage(product?.images)
	);
	const [openNutritionFactModal, setOpenNutritionFactModal] = useState(false);
	useEffect(() => {
		if (!ingredient.product) {
			setIngredient({ ...OverviewState, product });
		}
	}, [product, ingredient]);
	useEffect(() => {
		setNutritionFactImage(findFactPanelImage(product?.images));
	}, [product]);

	return (
		<div>
			{product?.description && <p className='product-description'> {product?.description}</p>}
			<div className='ingredients-container'>
				<div className='ingredients-heading'>Ingredients</div>
				<div className='ingredients-description'>
					{ingredient.product?.ingredientsList && ingredient.product?.ingredientsList.length > 0
						? ingredient.product?.ingredientsList?.join(', ')
						: ingredient.emptyIngredientText}
				</div>
				<div className='allergens'>
					<b>Allergens:</b>{' '}
					{product?.allergens && product?.allergens.length > 0
						? product?.allergens.join(', ')
						: 'N/A'}
				</div>
				{nutritionFactImage && (
					<div
						data-testid='nutrition-fact-link'
						className='view_nutrition'
						onClick={() => setOpenNutritionFactModal(!openNutritionFactModal)}
					>
						View Nutrition Facts Label
					</div>
				)}
			</div>
			<div data-testid='nutrition-fact-modal' className='nutrition-fact-modal'>
				<NutritionFactModalComponent
					image={nutritionFactImage}
					showModal={openNutritionFactModal}
					onCloseModal={() => setOpenNutritionFactModal(false)}
				/>
			</div>
		</div>
	);
};
